import { getQuestionType } from '@exam-management/common/utils';
import { getDifficultyType } from '@exam-management/components';
import { QBankStructureLevelCategory, TagCategory, Verdict } from '@exam-management/graphql';
import { matchPath } from 'react-router-dom';

import { type QuestionListDataGridRow } from '../../components';
import { type QuestionWithVerdicts, type QuestionVerdict } from '../../providers';

export function sortQuestionByRefCode(
  currentQuestionRefCode: string,
  candidateQuestionRefCode: string,
) {
  return currentQuestionRefCode.localeCompare(candidateQuestionRefCode, undefined, {
    numeric: true,
  });
}

function getQuestionDetailsPath(locationPathname: string) {
  const matchedMyTask = matchPath('/my-task/*', locationPathname);
  if (matchedMyTask) {
    return '/my-task/question-review/:taskId/question-details/:questionId';
  }
  return '/task-management/question-review/:taskId/question-details/:questionId';
}

function getReviewResultVariant(
  verdicts: QuestionVerdict[],
): QuestionListDataGridRow['reviewResult'] {
  if (!verdicts.length) return null;

  const approved = verdicts.filter(({ verdict }) => verdict === Verdict.Approved).length;
  const rejected = verdicts.filter(({ verdict }) => verdict === Verdict.Rejected).length;
  const total = verdicts.length;

  if (approved === total) return 'approved';
  if (rejected === total) return 'rejected';
  if (approved > 0 && rejected > 0) return 'partially-approved';

  return null;
}

export function mapQuestionsToQuestionRows(
  questions: QuestionWithVerdicts[],
  taskId: string,
  locationPathname: string,
): QuestionListDataGridRow[] {
  return [...questions]
    .sort((a, b) => sortQuestionByRefCode(a.refCode, b.refCode))
    .map((question, index) => {
      const chapter = question.questionStructures?.find(
        (qs) => qs.levelItem?.qBankStructureLevel?.category === QBankStructureLevelCategory.Chapter,
      );

      const difficultyType = getDifficultyType(
        question.tags?.find((tag) => tag.category === TagCategory.Difficulty)?.name ?? '',
      );

      const calculationType =
        question.tags?.find((tag) => tag.category === TagCategory.Calculation)?.name ?? '';

      return {
        id: question.id,
        no: index + 1,
        qId: question.refCode,
        locationName: chapter?.levelItem?.tag?.name ?? 'ไม่ระบุ',
        type: getQuestionType(question.questionGroup?.type),
        difficultyType,
        calculateType: calculationType,
        itemSetCount: question.questionGroup?.totalQuestions ?? null,
        itemSetName: question.questionGroup?.name ?? null,
        reviewResult: getReviewResultVariant(question.verdicts),
        goToPath: getQuestionDetailsPath(locationPathname),
        questionId: question.id,
        taskId,
      };
    });
}
